import { defineStore } from 'pinia'
import { useCartStore } from '~/stores/cart'

export const useKioskStore = defineStore('kiosk', {
  state: () => ({
    emptyPatient: {
      age: 'adult',
      birth_date: null,
      isNoPesel: false,
      first_name: '',
      last_name: '',
      email: '',
      pesel: '',
      country: 'PL',
      country_code: '48',
      phone_number_country_calling_code: '48',
      phone_number: '',
      sex: '',
    },
    patient: {
      age: 'adult',
      birth_date: null,
      isNoPesel: false,
      first_name: '',
      last_name: '',
      email: '',
      pesel: '',
      country: 'PL',
      country_code: '48',
      phone_number_country_calling_code: '48',
      phone_number: '',
      sex: '',
    },
    waitingForPayment: false,
    errors: {},
  }),

  actions: {
    clearStore() {
      this.patient = { ...this.emptyPatient }
      this.errors = {}
    },
    async storeOrder() {
      this.errors = {}
      const cartStore = useCartStore()
      let examinations = cartStore.items.map((examination) => ({
        id: examination.id,
        price: examination.price,
      }))

      return usePostApi('/referrals/pay', {
        homeService: false,
        facility_id: cartStore?.selectedFacility?.id,
        reservation_id: null,
        appointment: null,
        paymentMethod: 'kiosk',
        patients: [
          {
            id: null,
            first_name: this.patient.first_name,
            last_name: this.patient.last_name,
            pesel: this.patient.pesel,
            isNoPesel: !this.patient.pesel,
            birth_date: this.patient.birth_date,
            age: this.patient.age,
            phone_number: this.patient.phone_number,
            country_code: this.patient.country_code,
            country: this.patient.country,
            examinations,
          },
        ],
        examinations: cartStore.items,
        address: {
          first_name: this.patient.first_name,
          last_name: this.patient.last_name,
          country: this.patient.country,
          phone_number_country: this.patient.country,
          phone_number_country_calling_code: this.patient.country_code,
          national_phone_number: this.patient.phone_number,
          email: this.patient.email,
          isWithoutRegister: true,
          phone_is_valid: true,
        },
        wantInvoice: false,
      })
    },
    setWaitingForPayment(waiting) {
      this.waitingForPayment = waiting
    },
  },
})
